<template>
    <div
        v-if="entity" 
        class="m-2">
        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Башня</span>
            <span class="w-2/3">{{ getTowers(entity.tower_id) }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Этаж</span>
            <span class="w-2/3">{{ entity.floor }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Апартаменты</span>
            <span class="w-2/3">{{ entity.appartment }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Тип доставки</span>
            <span class="w-2/3">{{ entity.delivery_type }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Консьерж</span>
            <span 
                class="w-2/3 cursor-pointer hover:underline text-purple-700"
                @click="$router.push(`/concierges/${entity.concierge_id}`)">
                {{ getConcierge(entity.concierge_id) }}
            </span>
        </div>
        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Время доставки</span>
            <span class="w-2/3">{{ created_at }}</span>
        </div>

    </div>
</template>

<script>
    const moment = require('moment');

    export default {
        props: {
            entity: {
                type: Object,
                default: () => {},
            },
        },

        data: () => ({
            tower: {},
            concierge: {},
            entity: {},
            created_at: '',
        }),

        async created() {
            if (this.entity?.id) {
                if (this.entity?.concierge) {
                    this.concierge = this.entity?.concierge;
                }
                if (this.entity?.towerObj) {
                    this.tower = this.entity?.towerObj
                }
            }

            if (this.entity?.created_at) {
                this.created_at = moment(this.entity.created_at).format('YYYY-MM-DD HH:mm:ss');
            }
        },

        methods: {
            getTowers(id) {
                if (this.tower?.id) {
                   return this.tower?.address;
                }
                return '';
            },
            getConcierge(id) {
                if (this.concierge?.id) {
                    return `${this.concierge?.name} ${this.concierge?.phone}`
                }
                return '';
            },
        },
    };
</script>
